import api from "../../utils/api/api.utils";
import { GENERATOR_PARAMS } from "./card.constants";
export var markAllAsRead = function () {
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/mark-all-as-read"), {
        isV2: true,
    });
};
